(function () {
  // Gallery thumbnails
  var main = document.getElementById('gs-main-image');
  document.querySelectorAll('.product__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!main) return;
      main.src = btn.getAttribute('data-src');
      main.removeAttribute('srcset');
      document.querySelectorAll('.product__thumb').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  // Buy button on product page: one copy, straight to checkout
  var form = document.getElementById('gs-product-form');
  if (!form) return;
  var button = document.getElementById('gs-buy-button');
  var sending = false;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sending) return;
    sending = true;
    if (button) button.classList.add('is-locked');
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .catch(function () {})
      .then(function () { HTMLFormElement.prototype.submit.call(form); });
  });
})();

(function () {
  // Barra di acquisto fissa
  var bar = document.querySelector('[data-sticky-buy]');
  if (bar) {
    var link = bar.querySelector('a');
    var onScroll = function () {
      var show = window.scrollY > Math.min(700, window.innerHeight * 0.9);
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (link) link.tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();

(function () {
  // Schede delle aree
  document.querySelectorAll('.areas').forEach(function (sec) {
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('[data-area-tab]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      if (tab.scrollIntoView && window.innerWidth < 750) tab.scrollIntoView({ block: 'nearest', inline: 'center' });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select(tabs[(i + 1) % tabs.length], true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select(tabs[(i - 1 + tabs.length) % tabs.length], true); }
      });
    });
  });
})();

(function () {
  // Dubbi: sul telefono mostra i primi 4, poi "Mostra altri"
  document.querySelectorAll('[data-chat-more]').forEach(function (btn) {
    var sec = btn.closest('.chat');
    var label = btn.textContent;
    btn.addEventListener('click', function () {
      var open = sec.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Mostra meno' : label;
    });
  });
})();
